export const MANAGE_CUSTOMER = { code: '0', name: 'Customer' };
export const MANAGE_LOGISTIC = { code: '1', name: 'Transporter' };

export const MANAGE_USER_LIST = [MANAGE_CUSTOMER, MANAGE_LOGISTIC];
